const SuccessIcon = ({ className = '' }) => (
  <svg
    width='121'
    height='121'
    viewBox='0 0 121 121'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <circle
      cx='60.7262'
      cy='60.3341'
      r='47.3268'
      fill='#0FD08B'
      stroke='#0CA66F'
      strokeWidth='3'
    />
    <path
      d='M72.2165 45.07L53.7849 63.2963L47.961 57.5211C47.5894 57.1534 47.1481 56.8617 46.6624 56.6627C46.1767 56.4637 45.6561 56.3612 45.1304 56.3612C44.6047 56.3612 44.0841 56.4637 43.5984 56.6627C43.1127 56.8617 42.6714 57.1534 42.2998 57.5211L40.673 59.1298C40.3011 59.4973 40.0061 59.9337 39.8049 60.4139C39.6036 60.8942 39.5 61.409 39.5 61.9289C39.5 62.4488 39.6036 62.9636 39.8049 63.4438C40.0061 63.9241 40.3011 64.3605 40.673 64.728L50.8892 74.8305C51.2587 75.2021 51.6992 75.4972 52.1852 75.6987C52.6712 75.9002 53.1929 76.0039 53.7199 76.0039C54.2468 76.0039 54.7685 75.9002 55.2545 75.6987C55.7405 75.4972 56.1811 75.2021 56.5505 74.8305L79.3256 52.309C80.0776 51.5641 80.5 50.5545 80.5 49.5019C80.5 48.4493 80.0776 47.4397 79.3256 46.6947L77.6988 45.0861C76.9587 44.3939 75.9796 44.0069 74.9609 44.0039C73.9422 44.0009 72.9608 44.3822 72.2165 45.07Z'
      fill='white'
    />
    <circle
      cx='60.5'
      cy='60.1265'
      r='59'
      stroke='#0FD08B'
      strokeWidth='2'
      strokeDasharray='4 4'
    />
  </svg>
)

export default SuccessIcon
